<template>
  <div>
    <div>
      <v-row>
        <v-col cols="12">
          <gg-card-title v-if="mode === 'onboarding'" class="pt-0">
            Let's get
            <span v-if="dataLoaded">{{ serviceDomain }}</span>
            <v-progress-circular indeterminate color="primary" width="3" size="18" v-else />
            started!
          </gg-card-title>
          <gg-card-title v-else class="pt-0">
            Quick Launch Wizard -
            <span v-if="dataLoaded">{{ serviceDomain }}</span>
            <v-progress-circular indeterminate color="primary" width="3" size="18" v-else />
          </gg-card-title>

          <v-stepper v-if="mode !== 'onboarding'" v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">
                Choose Path
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">
                Setup
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                Confirm
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </v-col>
      </v-row>
    </div>

    <step-one v-show="step === 1" />
    <step-two v-if="step === 2" />
    <step-three v-if="step === 3" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import StepOne from '@/components/Wizard/StepOne/StepOne'
import StepTwo from '@/components/Wizard/StepTwo/StepTwo'
import StepThree from '@/components/Wizard/StepThree/StepThree'
require('@/assets/wizard-font/styles.css')

export default {
  name: 'WizardView',
  components: {
    StepOne, StepTwo, StepThree
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      step: 'wizard/step',
      serviceDomain: 'wizard/serviceDomain',
      mode: 'wizard/mode'
    }),
    dataLoaded () {
      return this.serviceDomain !== ''
    },
  },
  beforeDestroy () {
    this.clearWizardStore()
    this.clearWizardModelStore()
  },
  methods: {
    ...mapMutations({
      clearWizardStore: 'wizard/CLEAR_WIZARD_STORE',
      clearWizardModelStore: 'wizard_model/CLEAR_WIZARD_STORE'
    })
  }
}
</script>

<style src="@/assets/wizard-font/styles.css">

</style>
